<template>
  <v-card class="backoffice-table" outlined>
    <v-data-table
      :headers="headers"
      :items="items"
      :mobile-breakpoint="0"
      hide-default-footer
    >
      <template v-slot:item="{ item, index }">
        <tr class="ranking-row">
          <td>{{ index + 1 }}</td>
          <td>
            <v-list-item>
              <v-list-item-avatar class="ranking-avatar" size="24">
                <v-img
                  :src="avatar(item.user.photo)"
                ></v-img>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title class="ranking-title">{{
                  item.user.name
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </td>
          <td>{{ item.totalBets }} ( {{ openBets(item) }} abertas)</td>
          <td class="green-td" style="color: #26ab5e;">{{ item.greens }}</td>
          <td class="red-td">{{ item.reds }}</td>
          <td>{{ parseFloat(item.points).toFixed(2) }}</td>
        </tr>
      </template>
      <!-- BODY APPEND -->
      <template v-slot:[`body.append`]="{ headers }">
        <tr v-for="n in footerRows" :key="'tr-' + n">
          <td :colspan="headers.length"></td>
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<style scoped>
td {
  font-family: Gilroy-SemiBold;
  line-height: 24px;
  height: 60px !important;
  padding: 2px 8px !important;
}
.gray-td {
  font-size: 12px !important;
  color: #bcc5cc;
}
.green-td {
  color: #26ab5e;
}
.red-td {
  color: #f83030;
}
.gray-btn {
  font-family: Gilroy-SemiBold;
  font-size: 14px !important;
  line-height: 24px;
  color: #9aabb8;
}
.ranking-row {
  height: 64px;
}
.ranking-avatar {
  border: 2px solid #26ab5e;
}
.ranking-row:nth-of-type(1) .ranking-avatar,
.ranking-row:nth-of-type(1) .v-badge__badge {
  border-color: #ffc121;
  background-color: #ffc121 !important;
}
.ranking-row:nth-of-type(2) .ranking-avatar,
.ranking-row:nth-of-type(2) .v-badge__badge {
  border-color: #bcc5cc;
  background-color: #bcc5cc !important;
}
.ranking-row:nth-of-type(3) .ranking-avatar,
.ranking-row:nth-of-type(3) .v-badge__badge {
  border-color: #ab8626;
  background-color: #ab8626 !important;
}
.ranking-title {
  font-family: Gilroy-SemiBold;
  font-size: 14px;
  line-height: 24px;
  color: #304351 !important;
}
@media only screen and (max-width: 1024px) {
  .backoffice-table >>> .v-data-table__wrapper {
    overflow: auto;
  }
  .backoffice-table >>> table {
    width: 600px !important;
  }
}
</style>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "TiroCerteiroTable",
  props: { tableHeader: Array, tableData: Array },
  data: () => ({
    headers: [
      { text: "#", value: "name" },
      { text: "Utilizador", value: "user.name" },
      { text: "Nº de Apostas", value: "prognostics" },
      { text: "Greens", value: "greens" },
      { text: "Reds", value: "reds" },
      { text: "Pontos", value: "points" }
    ],
    itemsPerPage: 10
  }),
  methods: {
    openBets(userRanking) {
      return userRanking.prognostics.filter(item => {
        if (item.status == "OPEN") {
          return item;
        }
      }).length;
    },
    avatar(photo) {
      if(photo) {
        return photo;
      } else {
        return require("../assets/images/avatar.png");
      }      
    },
  },
  computed: {
    items() {
      return this.tableData;
    },
    footerRows() {
      const rows = this.itemsPerPage - this.items.length;
      return rows >= 0 ? rows : 0;
    }
  }
});
</script>